import api from './index'

export interface MessageReport {
  id: number
  message_id: number
  reporter_id: number
  reported_user_id: number
  entity_type: string
  entity_id: number
  reason: 'spam' | 'harassment' | 'hate_speech' | 'violence' | 'inappropriate_content' | 'scam' | 'other'
  description?: string
  status: 'pending' | 'reviewed' | 'resolved' | 'dismissed'
  admin_notes?: string
  reviewed_by?: number
  reviewed_at?: string
  created_at: string
  updated_at: string
  message?: {
    id: number
    text?: string
    user_id: number
    user?: {
      id: number
      username: string
      image?: string
    }
    attachments?: any[]
  }
  reporter?: {
    id: number
    username: string
    image?: string
  }
  reportedUser?: {
    id: number
    username: string
    image?: string
  }
  reviewer?: {
    id: number
    username: string
  }
}

export interface ReportsResponse {
  success: boolean
  data: MessageReport[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

export interface ReportStats {
  pending: number
  reviewed: number
  resolved: number
  dismissed: number
  total: number
  last_24h: number
}

export const reportsApi = {
  // Получить список жалоб
  async getReports(params?: { status?: string; reason?: string; date_from?: string; date_to?: string; page?: number; limit?: number }): Promise<ReportsResponse> {
    const token = localStorage.getItem('admin_token')
    const response = await api.get('/chat/admin/reports', {
      params,
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  },

  // Получить статистику жалоб
  async getStats(): Promise<{ success: boolean; data: ReportStats }> {
    const token = localStorage.getItem('admin_token')
    const response = await api.get('/chat/admin/reports/stats', {
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  },

  // Получить детали жалобы
  async getReport(reportId: number): Promise<{ success: boolean; data: MessageReport }> {
    const token = localStorage.getItem('admin_token')
    const response = await api.get(`/chat/admin/reports/${reportId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  },

  // Обновить статус жалобы
  async updateReport(
    reportId: number, 
    data: { status: 'reviewed' | 'resolved' | 'dismissed'; admin_notes?: string }
  ): Promise<{ success: boolean; message: string; data: MessageReport }> {
    const token = localStorage.getItem('admin_token')
    const response = await api.patch(`/chat/admin/reports/${reportId}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  },

  // Принять меры по жалобе (удалить сообщение / забанить пользователя)
  async takeAction(
    reportId: number,
    data: { delete_message?: boolean; ban_user?: boolean; admin_notes?: string }
  ): Promise<{ success: boolean; message: string; actions: string[] }> {
    const token = localStorage.getItem('admin_token')
    const response = await api.post(`/chat/admin/reports/${reportId}/take-action`, data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  }
}

// Маппинг причин жалоб на русский
export const reasonLabels: Record<string, string> = {
  spam: 'Спам',
  harassment: 'Оскорбления',
  hate_speech: 'Разжигание ненависти',
  violence: 'Насилие',
  inappropriate_content: 'Неприемлемый контент',
  scam: 'Мошенничество',
  other: 'Другое'
}

// Маппинг статусов на русский
export const statusLabels: Record<string, string> = {
  pending: 'Ожидает',
  reviewed: 'На рассмотрении',
  resolved: 'Решено',
  dismissed: 'Отклонено'
}

// Цвета для статусов
export const statusColors: Record<string, 'warning' | 'info' | 'success' | 'default'> = {
  pending: 'warning',
  reviewed: 'info',
  resolved: 'success',
  dismissed: 'default'
}
